import { render, staticRenderFns } from "./DealTradeChainNode.vue?vue&type=template&id=f02291d8&scoped=true"
import script from "./DealTradeChainNode.vue?vue&type=script&lang=js"
export * from "./DealTradeChainNode.vue?vue&type=script&lang=js"
import style0 from "./DealTradeChainNode.vue?vue&type=style&index=0&id=f02291d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02291d8",
  null
  
)

export default component.exports